var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 6.66671H11.1663V5.00004C11.1663 2.70004 9.29967 0.833374 6.99967 0.833374C4.69967 0.833374 2.83301 2.70004 2.83301 5.00004V6.66671H1.99967C1.08301 6.66671 0.333008 7.41671 0.333008 8.33337V16.6667C0.333008 17.5834 1.08301 18.3334 1.99967 18.3334H11.9997C12.9163 18.3334 13.6663 17.5834 13.6663 16.6667V8.33337C13.6663 7.41671 12.9163 6.66671 11.9997 6.66671ZM6.99967 14.1667C6.08301 14.1667 5.33301 13.4167 5.33301 12.5C5.33301 11.5834 6.08301 10.8334 6.99967 10.8334C7.91634 10.8334 8.66634 11.5834 8.66634 12.5C8.66634 13.4167 7.91634 14.1667 6.99967 14.1667ZM9.58301 6.66671H4.41634V5.00004C4.41634 3.57504 5.57467 2.41671 6.99967 2.41671C8.42467 2.41671 9.58301 3.57504 9.58301 5.00004V6.66671Z",
    fill: "#B12D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.b04fd208284b215f3b46b6711d5745e2.svg";
export { ForwardRef as ReactComponent };